"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Popover_1 = require("@material-ui/core/Popover");
var Typography_1 = require("@material-ui/core/Typography");
var HelpOutlineRounded_1 = require("@material-ui/icons/HelpOutlineRounded");
var LearnMorePopover = function (props) {
    var _a = React.useState(null), anchor = _a[0], setAnchor = _a[1];
    var handleOpen = function (event) {
        setAnchor(event.currentTarget);
    };
    var handleClose = function () {
        setAnchor(null);
    };
    var open = Boolean(anchor);
    return (React.createElement("div", { onMouseEnter: handleOpen },
        React.createElement(HelpOutlineRounded_1.default, { style: { float: "right", paddingRight: "0px" } }),
        React.createElement(Popover_1.default, { open: open, anchorEl: anchor, onClose: handleClose, anchorOrigin: {
                vertical: "center",
                horizontal: "right"
            }, transformOrigin: {
                vertical: "top",
                horizontal: "left"
            } },
            React.createElement(Typography_1.default, { style: { padding: "20px", maxWidth: "300px" } }, props.children)),
        React.createElement("div", { style: { float: "right", paddingRight: "5px" } }, "Learn More")));
};
exports.default = LearnMorePopover;
//# sourceMappingURL=LearnMorePopover.js.map